// @ts-nocheck
import BaseView from 'base_view';
import routingNumberValidator from 'views/contributions/account_info/validation/rails.validations.routing_number';

export default class NewView extends BaseView {
  constructor() {
    super();
    window.ClientSideValidations.validators.local.routing_number = routingNumberValidator;
    this.markPageLoaded();
  }
}
